import taxesService from '../../services/taxes'

const state = {
  taxes: [],

}

// getters
const getters = {
 
}

// actions
const actions = {
    async getTaxesAction (context) {
        await taxesService.getTaxesByRestaurant()
                            .then( data => 
                              { context.commit('setTaxesState', data) }); 
    },
    async addTaxAction (context, tax) {
        await taxesService.createTax(tax);
        context.commit('addTaxState', tax);
    },
    async updateTaxAction (context, tax) {
        await taxesService.updateTax(tax);
        context.commit('updateTaxState', tax);
    },
    async deleteTaxAction (context, tax) {

    }

}

// mutations
const mutations = {
    setTaxesState(state, taxes) {
        state.taxes = taxes;
    },
    addTaxState(state, tax) {
        state.taxes.push(tax);
    },
    updateTaxState(state, tax) {
        let index = state.taxes.findIndex(e => {
            return e.taxId === tax.taxId
        });
        if (index > -1) {
            state.taxes[index] = tax;
        }
    },
    deleteTaxState(state, tax) {
        let index = state.taxes.findIndex(e => {
            return e.taxId === tax.taxId
        });
        if (index > -1) {
            state.taxes.splice(index, 1);
        }
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}